module.exports = __webpack_public_path__ + "static/media/vu.3db09a68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/vu.png
// module id = 2020
// module chunks = 0